import React, { useEffect, useState } from "react";
import {
  ConfigProvider,
  Modal,
  Button,
  Form,
  Input,
  Image,
  Row,
  Col,
  Rate,
  Alert,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { submitRating } from "../api/repositories";
import ICPoints from "../assets/images/svgs/ic_learningpoints_programdesc.svg";
import ICLightBehind from "../assets/images/svgs/ic_lightrotatebadges_popuprewardrating.svg";
import HeaderGreatJobEN from "../assets/images/png/components/img_header_greatjob_EN.png";
import HeaderGreatJobNoRatingEN from "../assets/images/png/components/img_header_greatjob_norating_EN.png";
import HeaderHelpUsEN from "../assets/images/png/components/img_header_helpusimprove_EN.png";
import { setInvalidToken } from "../redux/features/main/invalidTokenSlice";

// img header ID
import HeaderGreatJobID from "../assets/images/png/components/img_header_greatjob_ID.png";
import HeaderGreatJobNoRatingID from "../assets/images/png/components/img_header_greatjob_norating_ID.png";
import HeaderHelpUsID from "../assets/images/png/components/img_header_helpusimprove_ID.png";

import HeaderGreatJobMobileEN from "../assets/images/png/components/mobile/img_header_greatjob_EN_mobile.png";
import HeaderGreatJobMobileID from "../assets/images/png/components/mobile/img_header_greatjob_ID_mobile.png";
import HeaderGreatJobMobileNoRatingEN from "../assets/images/png/components/mobile/img_header_greatjob_norating_EN_mobile.png";
import HeaderGreatJobMobileNoRatingID from "../assets/images/png/components/mobile/img_header_greatjob_norating_ID_mobile.png";

// for translate
import { useTranslation } from "react-i18next";

import ModalSuccessCheck from "../components/ModalSuccessCheck";
import { ColorSecondary, ColorPrimary } from "../config/constant/color/index";

import { backgroundCard, colorStar } from "../config/constant/color/index";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const { TextArea } = Input;

const ModalRating = ({
  hasRating,
  isSubmit,
  isCompleted,
  pointClaimed,
  badgesState,
  currModuleExit,
  trigerExitModule,
  setHasRating,
  setIsSubmit,
  setIsCompleted,
  setPointClaimed,
  setBagdesState,
  setTrigerExitModule,
  isFetchRating,
  mainState,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [ratePoint, setRatePoint] = useState(0);
  const [textFeedback, setTextFeedback] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [modalSuccessStat, setModalSuccessStat] = useState(false);
  const [modalRating, setModalNoRating] = useState(false);

  const url = window.location.pathname;
  const arrId = url.split("/");
  const journeyIdPosition = arrId.indexOf("journey");
  const courseIdPosition = arrId.indexOf("course");
  const moduleIdPosition = arrId.indexOf("module");
  const moduleSupIdPosition = arrId.indexOf("supporting");
  const currentJourneyId = parseInt(arrId[journeyIdPosition + 1]);
  const currentCourseId = parseInt(arrId[courseIdPosition + 1]);
  const currentModuleId = parseInt(arrId[moduleIdPosition + 1]);
  const currentModuleSupId = parseInt(arrId[moduleSupIdPosition + 1]);

  const screens = useBreakpoint();
  const isScallingVersion =
    (window.innerWidth <= 991 && window.innerWidth >= 768) ||
    window.innerWidth === 581;
  const isMobileVersion = screens.xs;

  var navigate = useNavigate();

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (type, placement, message) => {
    api[type]({
      message: message,
      placement,
    });
  };

  const handleSubmitRating = async () => {
    if (ratePoint !== undefined && ratePoint !== 0 && btnDisabled === false) {
      const payload = {
        module_id: currModuleExit.id,
        rating_point: ratePoint,
        feedback: textFeedback,
      };

      try {
        const { status, message, description, data } = await submitRating({
          data: payload,
        });
        // console.log(status);
        dispatch(setInvalidToken(status));
        if (status === 200) {
          // openNotification("success", 'bottom', message)
        } else {
          // openNotification("error", 'bottom', message)
        }
      } catch (err) {
        openNotification("error", "bottom", err);
      } finally {
        setOpenModal(false);

        // reset all rating State
        setHasRating(-1);
        setIsSubmit(0);
        setIsCompleted(0);
        setPointClaimed(0);
        setBagdesState((prevState) => {
          return {
            ...prevState,
            badges_id: null,
            journey_id: null,
            badges_thumbnail: null,
            badges_name: null,
          };
        });

        // reset all form and button state
        setBtnDisabled(true);
        setTextFeedback("");
        setRatePoint(0);
        setModalSuccessStat(true);

        if (isMobileVersion || isScallingVersion) {
          // navigate(mainState.popupStream.url); //kembali ke halaman module
          navigate(
            `/my-learning-journey/journey/${currentJourneyId}/course/${currentCourseId}`,
          );
        }
      }
    }
  };

  const closeModalNoRating = () => {
    setModalNoRating(false);

    // reset all rating State
    setHasRating(-1);
    setIsSubmit(0);
    setIsCompleted(0);
    setPointClaimed(0);
    setBagdesState((prevState) => {
      return {
        ...prevState,
        badges_id: null,
        journey_id: null,
        badges_thumbnail: null,
        badges_name: null,
      };
    });

    // reset all form and button state
    setBtnDisabled(true);
    setTextFeedback("");
    setRatePoint(0);
  };

  useEffect(() => {
    // console.log({
    //   isFetchRating,
    //   hasRating,
    //   isSubmit,
    //   isCompleted,
    //   pointClaimed,
    //   badgesState,
    //   trigerExitModule,
    //   mainState,
    // });
    if (isFetchRating === false) {
      if (isMobileVersion || isScallingVersion) {
        if (isCompleted === 1) {
          if (hasRating === 1 && isSubmit === 0 && trigerExitModule === true) {
            setOpenModal(true);
          } else if (
            hasRating === 1 &&
            isSubmit === 1 &&
            trigerExitModule === true
          ) {
            if (badgesState.badges_id !== null || pointClaimed > 0) {
              setModalNoRating(true);
            } else {
              setHasRating(-1);
              // navigate(mainState.popupStream.url); //kembali ke halaman module
              navigate(
                `/my-learning-journey/journey/${currentJourneyId}/course/${currentCourseId}`,
              );
              window.location.reload();
              setTrigerExitModule(false);
            }
          } else if (hasRating === 0 && trigerExitModule === true) {
            if (badgesState.badges_id !== null || pointClaimed > 0) {
              setModalNoRating(true);
            } else {
              setHasRating(-1);
              setTrigerExitModule(false);
              // navigate(mainState.popupStream.url); //kembali ke halaman module
              navigate(
                `/my-learning-journey/journey/${currentJourneyId}/course/${currentCourseId}`,
              );
              window.location.reload();
            }
          } else {
            setHasRating(-1);
            setTrigerExitModule(false);
            // navigate(mainState.popupStream.url); //kembali ke halaman module
            navigate(
              `/my-learning-journey/journey/${currentJourneyId}/course/${currentCourseId}`,
            );
          }
        } else {
          setHasRating(-1);
          setTrigerExitModule(false);
          // navigate(mainState.popupStream.url); //kembali ke halaman module
          navigate(
            `/my-learning-journey/journey/${currentJourneyId}/course/${currentCourseId}`,
          );
          window.location.reload();
        }
      } else {
        if (isCompleted === 1) {
          // KONDISI 1 (Popup with submit Form)
          // jika terdapat rating, module sudah completed, dan belum submit rating makan Popup pengisian rating muncul
          // terkait kemunculan tipe header flexible karena fetch rating, fetch badges, dan fetch point terpisah:
          // - badges only
          // - point only
          // - badges + point
          // - no badges + no point (Header Help Us Improve)
          // yang penting Popup pengisian rating muncul
          if (
            hasRating === 1 &&
            isCompleted === 1 &&
            isSubmit === 0 &&
            trigerExitModule === true
          ) {
            setOpenModal(true);
          }

          // KONDISI 2 (Popup without submit Form)
          // jika terdapat rating, module sudah completed, dan sudah submit rating maka...
          if (
            hasRating === 1 &&
            isCompleted === 1 &&
            isSubmit === 1 &&
            trigerExitModule === true
          ) {
            // cek apakah ada badges atau point, jika ada maka Popup tanpa pengisian rating muncul
            if (badgesState.badges_id !== null || pointClaimed > 0) {
              setModalNoRating(true);
            } else {
              setHasRating(-1);
            }
          }

          // KONDISI 3 (Popup without submit Form)
          // jika tidak terdapat rating, dan module sudah completed maka...
          if (
            hasRating === 0 &&
            isCompleted === 1 &&
            trigerExitModule === true
          ) {
            // cek apakah ada badges atau point, jika ada maka Popup tanpa pengisian rating muncul
            if (badgesState.badges_id !== null || pointClaimed > 0) {
              setModalNoRating(true);
            } else {
              setHasRating(-1);
            }
          }

          // OlD METHOD v1
          // if(hasRating === 0 && trigerExitModule === true || hasRating === 1 && isSubmit === 1 && trigerExitModule === true
          //     || hasRating === 1 && isCompleted === 0 && trigerExitModule === true
          // ) {
          //     navigate(mainState.popupStream.url);
          //     setHasRating(-1);
          // }
        } else {
          setHasRating(-1);
        }

        navigate(mainState.popupStream.url); // always navigate to target url
        setTrigerExitModule(false);
      }
    }
  }, [isFetchRating]);

  useEffect(() => {
    if (openModal === true) {
      if (isMobileVersion || isScallingVersion) {
        document
          .getElementById("text-area-reward-rating-mobile")
          .setAttribute(
            "placeholder",
            t("feature.feature_mylj.popup_rating.feedback_prompt"),
          );
      } else {
        document
          .getElementById("text-area-reward-rating")
          .setAttribute(
            "placeholder",
            t("feature.feature_mylj.popup_rating.feedback_prompt"),
          );
      }
    }
  }, [openModal]);

  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadiusLG: 16,
          fontFamily: "Roboto",
        },
      }}
    >
      {contextHolder}
      <Modal
        open={openModal}
        maskClosable="false"
        closeIcon={null}
        transitionName="ant-fade"
        width={
          isMobileVersion ? (isScallingVersion ? `${585 * 0.9}px` : "90%") : 480
        }
        centered
        footer={null}
      >
        <div className="popup-rating-header" style={{ position: "relative" }}>
          <div className="popup-header-background-wrapper">
            <Image
              preview={false}
              style={{
                borderRadius: "16px",
                // height: isMobileVersion ? "328px" : "auto",
                height: "auto",
              }}
              src={
                badgesState.badges_id !== null || pointClaimed > 0
                  ? i18n.language === "en"
                    ? isMobileVersion
                      ? HeaderGreatJobMobileEN
                      : HeaderGreatJobEN
                    : isMobileVersion
                    ? HeaderGreatJobMobileID
                    : HeaderGreatJobID
                  : i18n.language === "en"
                  ? HeaderHelpUsEN
                  : HeaderHelpUsID
              }
              fallback={
                i18n.language === "en" ? HeaderHelpUsEN : HeaderHelpUsID
              }
              alt="Great Job"
            />
          </div>
          <div
            className="popup-header-achievement-wrapper"
            style={{
              position: "absolute",
              bottom: "18px",
              width: "100%",
              display:
                badgesState.badges_id !== null || pointClaimed > 0
                  ? "flex"
                  : "none",
              justifyContent: "space-evenly",
            }}
          >
            <div
              className="popup-header-points-wrapper"
              style={{
                textAlign: "center",
                position: "relative",
                display: pointClaimed > 0 ? "block" : "none",
              }}
            >
              <div className="popup-header-image-icon">
                <Image
                  className="light-behind"
                  preview={false}
                  width={150}
                  height={150}
                  src={ICLightBehind}
                  fallback={ICLightBehind}
                  alt="Light"
                />
                <Image
                  className="popup-header-image-points"
                  preview={false}
                  width={64}
                  height={64}
                  src={ICPoints}
                  fallback={ICPoints}
                  alt="Get Points"
                />
              </div>
              <div
                className="text-points"
                style={{
                  width: "154px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "14px" : "16px",
                  color: backgroundCard,
                  lineHeight:
                    isMobileVersion || isScallingVersion ? "100%" : "1.2",
                  marginTop: "8px",
                  zIndex: 11,
                  position: "relative",
                }}
              >
                +{pointClaimed} {t("feature.feature_mylj.popup_rating.points")}
              </div>
            </div>
            <div
              className="popup-header-badges-wrapper"
              style={{
                textAlign: "center",
                position: "relative",
                display: badgesState.badges_id !== null ? "block" : "none",
              }}
            >
              <div className="popup-header-image-icon">
                <Image
                  className="light-behind"
                  preview={false}
                  width={150}
                  height={150}
                  src={ICLightBehind}
                  fallback={ICLightBehind}
                  alt="Light"
                />
                <Image
                  className="popup-header-image-badges"
                  preview={false}
                  width={64}
                  height={64}
                  src={badgesState.badges_thumbnail}
                  fallback={ICPoints}
                  alt="Get Badges"
                />
              </div>
              <div
                className="text-badges"
                style={{
                  width: "154px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "14px" : "16px",
                  color: backgroundCard,
                  lineHeight:
                    isMobileVersion || isScallingVersion ? "100%" : "1.2",
                  marginTop: "8px",
                  zIndex: 11,
                  position: "relative",
                }}
              >
                {t("feature.feature_mylj.popup_rating.badge")} <br /> &quot;
                {badgesState.badges_name}&quot;
              </div>
            </div>
          </div>
        </div>
        <div className="popup-rating-body">
          <Row
            className="rating"
            style={{
              fontSize: "14px",
              paddingTop: "22px",
              paddingBottom: "24px",
              textAlign: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {t("feature.feature_mylj.popup_rating.rate_experience")}
            {openModal === true ? (
              <Rate
                value={ratePoint}
                style={{ fontSize: 40, marginTop: "9px", color: colorStar }}
                onChange={(val) => {
                  setRatePoint(val);
                  if (val > 0) {
                    setBtnDisabled(false);
                  } else {
                    setBtnDisabled(true);
                  }
                }}
              />
            ) : null}
          </Row>
          <Row className="feedback" style={{ justifyContent: "center" }}>
            <Form
              onFinish={handleSubmitRating}
              className="form-reward-rating"
              style={{
                width: "100%",
                padding:
                  isMobileVersion || isScallingVersion ? "0 18px" : "0 32px",
              }}
            >
              <Form.Item>
                <TextArea
                  className="form-control"
                  maxLength={170}
                  showCount={true}
                  rows={3}
                  id={
                    isMobileVersion || isScallingVersion
                      ? "text-area-reward-rating-mobile"
                      : "text-area-reward-rating"
                  }
                  value={textFeedback}
                  onChange={(e) => setTextFeedback(e.target.value)}
                  placeholder={
                    (isMobileVersion || isScallingVersion) &&
                    "Tell us more about your learning experience."
                  }
                />
              </Form.Item>
              <Row>
                <Col
                  span={24}
                  style={{
                    padding:
                      isMobileVersion || isScallingVersion ? "0" : "0 94px",
                    marginBottom:
                      isMobileVersion || isScallingVersion ? 18 : "32px",
                  }}
                >
                  <Button
                    disabled={btnDisabled}
                    role="button"
                    name="btn-change-password"
                    className="btn btn-sm btn-primary btn-block"
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      fontWeight: "500",
                      height:
                        isMobileVersion || isScallingVersion ? "40px" : "48px",
                      fontSize: "14px",
                    }}
                    htmlType="submit"
                  >
                    {t("feature.feature_mylj.popup_rating.submit")}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Row>
        </div>
      </Modal>

      <Modal
        open={modalRating}
        maskClosable="false"
        closeIcon={null}
        transitionName="ant-fade"
        width={
          isMobileVersion ? (isScallingVersion ? `${585 * 0.9}px` : "90%") : 480
        }
        centered
        footer={null}
      >
        <div className="popup-norating-header" style={{ position: "relative" }}>
          <div className="popup-norating-header-background-wrapper">
            <Image
              preview={false}
              style={{
                borderRadius: "16px",
                // height: isMobileVersion || isScallingVersion ? "328px" : "auto",
                height: "auto",
              }}
              src={
                i18n.language === "en"
                  ? isMobileVersion
                    ? HeaderGreatJobMobileNoRatingEN
                    : HeaderGreatJobNoRatingEN
                  : isMobileVersion
                  ? HeaderGreatJobMobileNoRatingID
                  : HeaderGreatJobNoRatingID
              }
              fallback={
                i18n.language === "en"
                  ? isMobileVersion
                    ? HeaderGreatJobMobileNoRatingEN
                    : HeaderGreatJobNoRatingEN
                  : isMobileVersion
                  ? HeaderGreatJobMobileNoRatingID
                  : HeaderGreatJobNoRatingID
              }
              alt="Great Job"
            />
          </div>
          <div
            className="popup-norating-header-achievement-wrapper"
            style={{
              position: "absolute",
              bottom: isMobileVersion || isScallingVersion ? "95px" : "105px",
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <div
              className="popup-norating-header-points-wrapper"
              style={{
                textAlign: "center",
                position: "relative",
                display: pointClaimed > 0 ? "block" : "none",
              }}
            >
              <div className="popup-norating-header-image-icon">
                <Image
                  className="light-behind"
                  preview={false}
                  width={150}
                  height={150}
                  src={ICLightBehind}
                  fallback={ICLightBehind}
                  alt="Light"
                />
                <Image
                  className="popup-norating-header-image-points"
                  preview={false}
                  width={64}
                  height={64}
                  src={ICPoints}
                  fallback={ICPoints}
                  alt="Get Points"
                />
              </div>
              <div
                className="text-points"
                style={{
                  width: "154px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: isMobileVersion ? "14px" : "16px",
                  color: backgroundCard,
                  lineHeight: isMobileVersion ? "100%" : "1.2",
                  marginTop: "8px",
                  zIndex: 11,
                  position: "relative",
                }}
              >
                +{pointClaimed} {t("feature.feature_mylj.popup_rating.points")}
              </div>
            </div>
            <div
              className="popup-norating-header-badges-wrapper"
              style={{
                textAlign: "center",
                position: "relative",
                display: badgesState.badges_id !== null ? "block" : "none",
              }}
            >
              <div className="popup-norating-header-image-icon">
                <Image
                  className="light-behind"
                  preview={false}
                  // width={isMobileVersion || isScallingVersion ? 72 : 150}
                  width={150}
                  height={150}
                  src={ICLightBehind}
                  fallback={ICLightBehind}
                  alt="Light"
                />
                <Image
                  className="popup-norating-header-image-badges"
                  preview={false}
                  width={64}
                  height={64}
                  src={badgesState.badges_thumbnail}
                  fallback={ICPoints}
                  alt="Get Badges"
                />
              </div>
              <div
                className="text-badges"
                style={{
                  width: "154px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize:
                    isMobileVersion || isScallingVersion ? "14px" : "16px",
                  color: backgroundCard,
                  lineHeight:
                    isMobileVersion || isScallingVersion ? "100%" : "1.2",
                  marginTop: "8px",
                  zIndex: 11,
                  position: "relative",
                }}
              >
                {t("feature.feature_mylj.popup_rating.badge")} <br /> &quot;
                {badgesState.badges_name}&quot;
              </div>
            </div>
          </div>
          <div
            className="popup-norating-button"
            style={{
              position: "absolute",
              bottom: isMobileVersion || isScallingVersion ? 18 : 32,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              padding:
                isMobileVersion || isScallingVersion ? "0 18px" : "unset",
            }}
          >
            <Button
              onClick={() => closeModalNoRating()}
              role="button"
              className="btn btn-sm btn-block"
              style={{
                background:
                  isMobileVersion || isScallingVersion
                    ? ColorPrimary
                    : ColorSecondary,
                color:
                  isMobileVersion || isScallingVersion
                    ? backgroundCard
                    : ColorPrimary,
                width: isMobileVersion || isScallingVersion ? "100%" : 227,
                borderRadius: "6px",
                border: "none",
                fontWeight: "500",
                height: isMobileVersion || isScallingVersion ? "40px" : "48px",
                fontSize: "14px",
              }}
            >
              OK
            </Button>
          </div>
        </div>
      </Modal>

      <ModalSuccessCheck
        mainState={mainState}
        confirmRating={true}
        textTitle={t("feature.feature_mylj.popup_rating.thank_you_feedback")}
        textDesc={t("feature.feature_mylj.popup_rating.your_input_helps")}
        modalSuccess={modalSuccessStat}
        setModalSuccess={setModalSuccessStat}
      />
    </ConfigProvider>
  );
};

export default ModalRating;
